import React, { lazy } from 'react';
import PageDurationIcon from '@/assets/images/menu/page-duration.react.svg?react';
import { AuthNodes } from '@/config/app/auth';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';

export const pageDurationRoutes = (): IRouteConfig[] => [
  {
    path: '/page-duration',
    name: '页面性能',
    authName: AuthNodes.PagePerfomance,
    icon: <MenuIcon icon={PageDurationIcon} fontSize={16} />,
    platforms: [
      CapitalPlatform.Android,
      CapitalPlatform.IOS,
      CapitalPlatform.VisionOS,
      CapitalPlatform.AppleTV,
    ],
    sort: 84,
    component: lazy(() => import('@/presentation/pages/page-duration')),
    disabledByFree: true,
  },
];

export default pageDurationRoutes;
